import { useMemo } from "react";
import { Typography, useTheme, Box } from "@mui/material";

import { useContext } from "react";
import { AppContext } from "../contextProviders/AppContext";
import { FormattedDate, FormattedTime } from "./common";
import { translation } from "./Dictionary";
import UpdateIcon from "@mui/icons-material/Update";
import RestoreIcon from "@mui/icons-material/Restore";

export default function ReservationSchedule() {
  const {
    FEATURE_FIXED_RESERVATION_DURATION,
    FEATURE_NO_TIME_SELECT,
    groups,
    language,
    reservationReturn,
    reservationStart,
  } = useContext(AppContext);
  const theme = useTheme();

  const startTimeLabel = useMemo(() => {
    const group = groups?.[0];
    if (FEATURE_FIXED_RESERVATION_DURATION) {
      return translation.get(language, "Start reservation text");
    }

    if (group === "gnista") {
      return translation.get(language, "Pick up accommodation text");
    } else {
      return translation.get(language, "Pick up text");
    }
  }, [groups, language, FEATURE_FIXED_RESERVATION_DURATION]);

  const returnTimeLabel = useMemo(() => {
    const group = groups?.[0];
    if (FEATURE_FIXED_RESERVATION_DURATION) {
      return translation.get(language, "End reservation text");
    }
    if (group === "gnista") {
      return translation.get(language, "Return accommodation text");
    } else {
      return translation.get(language, "Return text");
    }
  }, [groups, language, FEATURE_FIXED_RESERVATION_DURATION]);

  const schedule = [
    {
      date: reservationStart,
      label: startTimeLabel,
      icon: <UpdateIcon style={{ color: theme.palette.primary.icon }} />,
    },
    {
      date: reservationReturn,
      label: returnTimeLabel,
      icon: <RestoreIcon style={{ color: theme.palette.primary.icon }} />,
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        maxWidth: "400px",
        border: "1px solid rgba(0,0,0,0.25)",
        padding: "10px",
        borderRadius: "14px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {schedule.map((item, index) => (
          <Box
            key={`schedule-key-${index}`}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {item.icon}
            <Typography
              variant="body2"
              sx={{
                fontSize: "16px",
                fontWeight: "bolder",
                marginLeft: "5px",
                color: theme.palette.primary.mainText,
              }}
            >
              {item.label}
            </Typography>
          </Box>
        ))}
      </Box>
      <Box sx={{ display: "flex" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "center",
            marginLeft: "5px",
          }}
        >
          {schedule.map((item, index) => (
            <Typography
              key={`schedule-date-key-${index}`}
              variant="body2"
              sx={{
                color: theme.palette.primary.MainText,
                fontSize: "16px",
              }}
            >
              <FormattedDate date={item.date} />
            </Typography>
          ))}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "center",
          }}
        >
          {FEATURE_NO_TIME_SELECT ||
            (!FEATURE_FIXED_RESERVATION_DURATION &&
              schedule.map((item, index) => (
                <Typography
                  key={`schedule-time-key-${index}`}
                  variant="body2"
                  sx={{
                    color: theme.palette.primary.MainText,
                    fontSize: "16px",
                    marginLeft: "5px",
                  }}
                >
                  <FormattedTime date={item.date} />
                </Typography>
              )))}
        </Box>
      </Box>
    </Box>
  );
}
